export default __webpack_public_path__ + "static/media/gymrift-project-screenshot.ca40d965.png";